import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    FETCH(buildingId) {
      return this.get(links.CONTACT_FETCH(buildingId), {
        dataKey: "hydra:member",
      });
    },
    PUT(item) {
      return this.put(links.CONTACT_PUT(item.id), item);
    },
    POST(item) {
      return this.post(links.CONTACT_POST(), item);
    },
    REGISTER(item) {
      return this.post(links.REGISTER_CONTACT(), item);
    },
    REGISTER_GET_CONTACTS(meetingId) {
      let params = {};
      if (meetingId) {
        params["meeting_id"] = meetingId;
      }
      return this.get(links.CONTACT_MEETING_REGISTER() + "?" + qs.stringify(params));
    },
  },
};
